import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { useAppSelector } from '../../../redux/store';
import { CardDisplay } from './cardDisplay';
export const PlayerRevealedCardDisplay = ({ seatIndex, cardIndex, cardRenderProperties }) => {
    const cardRankChar = useAppSelector((state) => state.poker.revealedHands[seatIndex]?.[cardIndex].card?.rankChar);
    const cardSuitChar = useAppSelector((state) => state.poker.revealedHands[seatIndex]?.[cardIndex].card?.suitChar);
    const cardEmphasis = useAppSelector((state) => state.poker.revealedHands[seatIndex]?.[cardIndex].cardEmphasis);
    const currentShowdownStartTimestampMs = useAppSelector((state) => state.poker.currentShowdown?.startTimeStampMs);
    // numRevealedCards will be non-zero if the player is showing card backs only:
    const numRevealedCards = useAppSelector((state) => state.poker.revealedHands[seatIndex]?.length);
    const isFourColorDeckEnabled = useAppSelector((state) => state.selfData.isFourColorDeckEnabled);
    const animationProps = cardRankChar &&
        cardSuitChar &&
        currentShowdownStartTimestampMs !== undefined
        ? {
            startTimestampMs: currentShowdownStartTimestampMs,
            animationType: cardEmphasis === 'highlighted' ? 'ranked' : 'non-ranked'
        }
        : {};
    if (cardEmphasis === undefined || !numRevealedCards) {
        return null;
    }
    return (_jsx(CardDisplay, { pixiDataType: 'revealed-card', cardRankChar: cardRankChar, cardSuitChar: cardSuitChar, cardIndex: cardIndex, cardEmphasis: cardEmphasis, cardRenderProperties: cardRenderProperties, seatIndex: seatIndex, numCardsInGroup: numRevealedCards, isFourColorDeck: isFourColorDeckEnabled, dropShadowAlpha: 0.5, ...animationProps }));
};
